import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import classes from "./style.module.scss";
import { useDispatch } from "react-redux";
import { setUserAuthentication } from "../../../redux/ducks/auth";
import { destroySession } from "../../../redux/configurationStore";

// Small inline icon so the redesign doesn't need a new asset file - a
// plain door/exit glyph, sized to sit inside the teal-tinted badge above
// the title.
const LogoutGlyph = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 17L15 12L10 7"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 12H3"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LogoutModal = ({ closeModal }) => {
  const dispatch = useDispatch();

  const logOutUser = () => {
    sessionStorage.clear();
    dispatch(setUserAuthentication(false));
    dispatch(destroySession());
    closeModal();
  };

  return (
    <Box className={classes["logout-modal"]}>
      {/* A fresh mount every time this opens (see Header.js/SidebarHeader.js -
          the Modal no longer uses keepMounted) is what makes the entrance
          animation below replay on every single "Log out" click, not just
          the first one. */}
      <div className={classes["logout-card"]}>
        <button
          type="button"
          className={classes["close-btn"]}
          aria-label="Close"
          onClick={closeModal}
        >
          &times;
        </button>

        <div className={classes["icon-badge"]}>
          <LogoutGlyph />
        </div>

        <Typography
          id="keep-mounted-modal-title"
          className={classes["title"]}
          variant="h6"
          component="h2"
        >
          Log out of Modus?
        </Typography>
        <p id="keep-mounted-modal-description" className={classes["subtitle"]}>
          You&apos;ll need to sign back in to access your account.
        </p>

        <div className={classes["logout-modal-btns"]}>
          <button type="button" className={classes["no-btn"]} onClick={closeModal}>
            Cancel
          </button>
          <button type="button" className={classes["yes-btn"]} onClick={logOutUser}>
            Log out
          </button>
        </div>
      </div>
    </Box>
  );
};

export default LogoutModal;
